<!--
                               o8o                 .
                               `"'               .o8
   .oooo.o  .ooooo.  oooo d8b oooo  oo.ooooo.  .o888oo
  d88(  "8 d88' `"Y8 `888""8P `888   888' `88b   888
  `"Y88b.  888        888      888   888   888   888
  o.  )88b 888   .o8  888      888   888   888   888 .
  8""888P' `Y8bod8P' d888b    o888o  888bod8P'   "888"
                                     888
                                    o888o
 -->

<script>

import { TweenMax as Tween, TimelineMax as Line, Power1 } from 'gsap'

export default {

  name: 'AsideWidget',

  props: {
    content: [Object]
  },

  data () {
    return {
      tl: null
    }
  },

  methods: {
    beforeAppear () {
      const tl = this.tl = new Line({ paused: true })
      const group = []

      if (this.$refs.title) group.push(this.$refs.title)
      if (this.$refs.content) group.push(this.$refs.content)

      const rtl = this.content.alignment === 'right'
      const contentStart = rtl ? 0.3 : 0
      const mediaStart = rtl ? 0 : 0.3

      tl.staggerFrom(group, 1, {
        autoAlpha: 0,
        y: -20,
        ease: Power1.easeOut
      }, 0.1, contentStart)

      tl.from(this.$refs.media, 1, {
        autoAlpha: 0,
        ease: Power1.easeOut,
        // onUpdate: () => {
        //   const x = this.$refs.media.style.opacity * 100

        //   Tween.set(this.$refs.media, {
        //     clipPath: `polygon(0% 0%, ${x}% 0%, ${x}% 100%, 0% 100%)`
        //   })
        // }
      }, mediaStart)
    },

    appear () {
      this.tl.play()
    }
  }

}

</script>


<!--

  oooo                                                  .
  `888                                                .o8
   888   .oooo.   oooo    ooo  .ooooo.  oooo  oooo  .o888oo
   888  `P  )88b   `88.  .8'  d88' `88b `888  `888    888
   888   .oP"888    `88..8'   888   888  888   888    888
   888  d8(  888     `888'    888   888  888   888    888 .
  o888o `Y888""8o     .8'     `Y8bod8P'  `V88V"V8P'   "888"
                  .o..P'
                  `Y8P'
 -->


<template lang="pug">

.widget(:class="{ 'is-rtl': content.alignment === 'right' }")
  .widget__content
    .widget__main
      .widget__title(v-if="content.title" ref="title") {{ content.title }}
      .widget__description.markdown-container(v-md="content.description" ref="content")
    .widget__media: img(:src="content.media.url" alt="image" ref="media")

</template>


<!--
               .               oooo
             .o8               `888
   .oooo.o .o888oo oooo    ooo  888   .ooooo.   .oooo.o
  d88(  "8   888    `88.  .8'   888  d88' `88b d88(  "8
  `"Y88b.    888     `88..8'    888  888ooo888 `"Y88b.
  o.  )88b   888 .    `888'     888  888    .o o.  )88b
  8""888P'   "888"     .8'     o888o `Y8bod8P' 8""888P'
                   .o..P'
                   `Y8P'
 -->


<style lang="stylus" scoped>

.widget
  padding-top 100px
  padding-bottom 60px
  display flex
  justify-content center

  +below(1024px)
    padding 50px 0
  +mobile()
    justify-content flex-start
    padding 35px 0

    &.is-rtl
      justify-content flex-end

  &__content
    max-width 1138px
    width 100%
    display flex
    justify-content space-between
    padding 0 65px

    +hd()
      max-width 1548px

    +below(1024px)
      padding 0

    +mobile()
      flex-direction column-reverse

  &__main
    display flex
    flex-direction column
    justify-content center
    max-width 380px
    width 100%
    margin-left 60px
    margin-right 80px

    +hd()
      margin 0 auto

    +tablet()
      margin 0 50px

    +mobile()
      margin 0
      padding 0 30px
      max-width 455px

    .widget.is-rtl &
      +hd()
        margin 0 auto
      +above(768px)
        order 2

      +above(1024px)
        margin-right 60px
        margin-left 80px
      +mobile()
        margin-left auto

  &__title
    font-weight 500
    font-size 12px
    line-height 20px
    color blue
    padding-bottom 25px

  &__media
    max-width 475px
    min-width 340px
    width 100%
    overflow hidden

    +hd()
      max-width 700px

    +mobile()
      margin-bottom 25px
      min-width 0
      padding-left 24px

      .widget.is-rtl &
        margin-left auto
        padding-right 24px
        padding-left 0

    img
      width 100%
      height auto

</style>



// WEBPACK FOOTER //
// aside.vue?2cca9eb6